// extracted by mini-css-extract-plugin
export default {"contactUs":"ContactUsPage_contactUs__-+iyd","title":"ContactUsPage_title__kzxbi","info":"ContactUsPage_info__9fNO-"};